import React, { createContext, useContext, useMemo } from 'react'

export type Language = 'eng' | 'heb' | 'arb'
export type Direction = 'ltr' | 'rtl'

interface RTLContextType {
  isRTL: boolean
  language: Language
  direction: Direction
}

const RTLContext = createContext<RTLContextType | undefined>(undefined)

interface RTLProviderProps {
  children: React.ReactNode
  language?: Language
  direction?: 'ltr' | 'rtl' | 'auto'
}

export function RTLProvider({ children, language = 'eng', direction = 'auto' }: RTLProviderProps) {
  const contextValue = useMemo(() => {
    // Auto-detect RTL from language if direction is 'auto'
    let resolvedDirection: Direction
    
    if (direction === 'auto') {
      resolvedDirection = (language === 'heb' || language === 'arb') ? 'rtl' : 'ltr'
    } else {
      resolvedDirection = direction
    }

    const result = {
      isRTL: resolvedDirection === 'rtl',
      language,
      direction: resolvedDirection
    }



    return result
  }, [language, direction])

  return (
    <RTLContext.Provider value={contextValue}>
      <div dir={contextValue.direction}>
        {children}
      </div>
    </RTLContext.Provider>
  )
}

export function useRTL(): RTLContextType {
  const context = useContext(RTLContext)
  if (context === undefined) {
    throw new Error('useRTL must be used within an RTLProvider')
  }
  return context
} 